import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';

export enum UserType {
  Admin = 'admin',
  GroupManager = 'group-manager',
}

export enum UserRole {
  OrgPublisher = 'org_publisher',
  OrgAdmin = 'org_admin',
}
interface IInitialState {
  token: string | null;
  userType: UserType | null;
  userRole: UserRole | null;
  username: string | null;
  user: any;
  userHasPermissions?: boolean;
}
const initialState: IInitialState = {
  token: null,
  userType: null,
  userRole: null,
  user: null,
  username: null,
  userHasPermissions: true,
};
export const authSlice = createSlice({
  name: 'authSlice',
  initialState,
  reducers: {
    setToken: (state, action: PayloadAction<string | null>) => {
      state.token = action.payload;
    },
    setUserType: (state, action: PayloadAction<UserType | null>) => {
      state.userType = action.payload;
    },

    setUserRole: (state, action) => {
      state.userRole = action.payload;
    },

    setUser: (state, action) => {
      state.user = action.payload;
    },
    setUsername: (state, action: PayloadAction<string | null>) => {
      state.username = action.payload;
    },
    setUserHasPermissions: (state, action) => {
      state.userHasPermissions = action.payload;
    },
  },
});

export const { setToken, setUserRole, setUser, setUsername, setUserHasPermissions } = authSlice.actions;

export const tokenSelector = (state: RootState) => state.authSlice.token;
export const userTypeSelector = (state: RootState) => state.authSlice.userType;
export const userRoleSelector = (state: RootState) => state.authSlice.userRole;
export const userSelector = (state: RootState) => state.authSlice.user;
export const usernameSelector = (state: RootState) => state.authSlice.username;
export const userHasPermissionsSelector = (state: RootState) => state.authSlice.userHasPermissions;

export default authSlice.reducer;
